import React from "react";
import styled from "styled-components";

export default styled.form`
    width: 100%;
`;
